import React from 'react'
import { Image } from 'react-native'
import { styles } from './styles'
import logo from './logo.svg'

export const LogoDACI = () => <Image resizeMode="contain" style={styles.image} source={{uri:logo}} />
